import { Link } from 'react-router-dom';
import { Camera, Zap, Shield, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useCredits } from '@/hooks/useCredits';
import { useSession } from '@/lib/session';

export const DashboardPage = () => {
  const credits = useCredits();
  const userName =
    (useSession((s) => s.session?.user.user_metadata?.name as string | undefined)) ?? 'arquiteto';

  return (
    <div className="mx-auto max-w-5xl space-y-10 p-6 lg:p-10">
      <header className="space-y-2">
        <p className="text-sm text-muted-foreground">Olá, {userName}</p>
        <h1 className="text-3xl font-display">Transforme seu projeto em render fotorealista</h1>
        <p className="text-muted-foreground">
          {credits.isLoading
            ? 'Carregando seus créditos…'
            : `Você tem ${credits.data ?? 0} créditos disponíveis.`}
        </p>
      </header>

      <div className="grid gap-4 md:grid-cols-3">
        <Card className="flex flex-col">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Camera className="size-5 text-primary" />
              Render HD
            </CardTitle>
            <CardDescription>Sketch, planta ou foto → render fotorealista.</CardDescription>
          </CardHeader>
          <CardContent className="mt-auto">
            <Button asChild className="w-full">
              <Link to="/upload">Começar</Link>
            </Button>
          </CardContent>
        </Card>

        <Card className="flex flex-col">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Zap className="size-5 text-primary" />
              4 tiers de qualidade
            </CardTitle>
            <CardDescription>Draft, Standard, Premium 21:9 e Variants ×3. Escolha no briefing do render.</CardDescription>
          </CardHeader>
          <CardContent className="mt-auto">
            <Button asChild variant="secondary" className="w-full">
              <Link to="/upload">Ver opções</Link>
            </Button>
          </CardContent>
        </Card>

        <Card className="flex flex-col">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Clock className="size-5 text-primary" />
              ~35 segundos
            </CardTitle>
            <CardDescription>Entrega em até 40 segundos em alta resolução. Roda no navegador, sem instalar nada.</CardDescription>
          </CardHeader>
          <CardContent className="mt-auto text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <Shield className="size-4" /> Seus renders são privados.
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Pronto para começar?</CardTitle>
          <CardDescription>
            Carregue uma imagem da sua planta, sketch, maquete SketchUp ou foto do ambiente vazio.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild size="lg" className="w-full sm:w-auto">
            <Link to="/upload">Fazer primeiro render →</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
